<app-loading *ngIf="loading"></app-loading>
<div *ngIf="!loading">
    <div class="flex justify-content-between mb-6 mt-6">
        <div style="left: 30px; display: flex; width: 200px;">
            <div class="mt-2 col-3 strong">Model:</div>
            <div class="col-10">
                <app-dropdown [options]="this.modelService.models" [optionLabel]="'long_value'" [model]="this.modelService.model" (onChangeEvent)="onSeletedModelChange($event)" class="w-10"></app-dropdown>
            </div>
        </div>
        <app-esa-project-status [selectedProject]="selectedProject" (summaryDownloadAvailable)="onSummaryReportAvailable($event)"></app-esa-project-status>
    </div>
    <div class="border-bottom-1"></div>
    <div *ngIf="this.modelService.model != null">
        <p-scrollPanel [style]="{ width: '100%', height: '80vh' }">
            <div *ngIf="isSummaryReportAvailable" class="flex justify-content-center available-summary-label">
                Click on the Summary download button to get your results
            </div>
        </p-scrollPanel>
    </div>
</div>
<div *ngIf="this.modelService.models.length<= 0 && !loading">
    <h4>No models where found</h4>
</div>